export default {
  getLeads({ leads }) {
    return leads
  },

  getAtrasadas({ atrasadas }) {
    return atrasadas
  },

  getVenceAmanha({ venceAmanha }) {
    return venceAmanha
  },

  getvenceHoje({ venceHoje }) {
    return venceHoje
  }
}
